export const START_SESSION_HEARTBEAT_MSG = "start_sessionHB";
export const ERROR_MSG = "session-hb-error";
export const SESSION_KO_MSG = "session-ko";
